// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"35":"5cb7195a3c67a73cd3d6","266":"1596c6c0513ec60ec0c1"}[chunkId] + ".js";
};